// Shared DatePicker styles for consistency across the app
const logoColors = {
    primaryBlue: '#3f51b5',
    brightYellow: '#c4d835',
    darkBlue: '#2c387e',
    lightYellow: '#d4e157',
};

export const datePickerStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        '& input': {
            color: `${logoColors.brightYellow} !important`,
            WebkitTextFillColor: `${logoColors.brightYellow} !important`,
            fontWeight: `700 !important`,
        },
        '& fieldset': {
            borderColor: logoColors.brightYellow,
            borderWidth: '2px'
        },
        '&:hover fieldset': {
            borderColor: logoColors.brightYellow,
        },
        '&.Mui-focused fieldset': {
            borderColor: logoColors.brightYellow,
            borderWidth: '2px'
        }
    },
    '& .MuiInputBase-input': {
        color: `${logoColors.brightYellow} !important`,
        WebkitTextFillColor: `${logoColors.brightYellow} !important`,
        fontWeight: `700 !important`,
    },
    '& .MuiInputLabel-root': {
        color: `${logoColors.brightYellow} !important`,
        fontWeight: 600,
        '&.Mui-focused': {
            color: `${logoColors.brightYellow} !important`,
        },
        '&.MuiInputLabel-shrink': {
            color: `${logoColors.brightYellow} !important`,
        }
    },
    '& .MuiSvgIcon-root': {
        color: `${logoColors.brightYellow} !important`
    },
    '& input': {
        color: `${logoColors.brightYellow} !important`,
        WebkitTextFillColor: `${logoColors.brightYellow} !important`,
        fontWeight: `700 !important`,
    }
};

export const datePickerPopperStyles = {
    popper: {
        sx: {
            '& .MuiPaper-root': {
                backgroundColor: logoColors.darkBlue,
                border: `2px solid ${logoColors.brightYellow}`,
                borderRadius: '16px',
                boxShadow: '0 8px 32px rgba(44, 56, 126, 0.6)',
            },
            '& .MuiPickersCalendarHeader-root': {
                backgroundColor: logoColors.primaryBlue,
                color: logoColors.brightYellow,
                '& .MuiPickersArrowSwitcher-root': {
                    '& .MuiIconButton-root': {
                        color: logoColors.brightYellow,
                        '&:hover': {
                            backgroundColor: 'rgba(196, 216, 53, 0.2)',
                        }
                    }
                },
                '& .MuiPickersCalendarHeader-label': {
                    color: logoColors.brightYellow,
                    fontWeight: 700,
                }
            },
            '& .MuiDayCalendar-header': {
                '& .MuiTypography-root': {
                    color: logoColors.lightYellow,
                    fontWeight: 600,
                }
            },
            '& .MuiPickersDay-root': {
                color: `${logoColors.brightYellow} !important`,
                fontWeight: 500,
                '&:hover': {
                    backgroundColor: 'rgba(196, 216, 53, 0.2) !important',
                },
                '&.Mui-selected': {
                    backgroundColor: 'transparent !important',
                    color: `${logoColors.brightYellow} !important`,
                    fontWeight: 700,
                    borderRadius: '50% !important',
                    border: `2px solid ${logoColors.brightYellow} !important`,
                    '&:hover': {
                        backgroundColor: 'rgba(196, 216, 53, 0.2) !important',
                    }
                },
                '&.MuiPickersDay-today': {
                    border: `2px solid ${logoColors.lightYellow} !important`,
                    backgroundColor: 'transparent !important',
                    color: `${logoColors.lightYellow} !important`,
                },
                '&.Mui-disabled': {
                    color: 'rgba(196, 216, 53, 0.4) !important',
                }
            }
        }
    }
};

